// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalSwitchCustomer__rKsHj {
  height: 464px;
  width: 372px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.modalBody__bJ9Qf {
  padding: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.modalBodyTitle__S1JId {
  margin-bottom: 35px;
  text-align: center;
  color: var(--header-title-main);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-transform: uppercase;
}

.extraText__Qg3OK {
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: none;
  display: block;
  margin: 25px auto 0;
}

.modalFooter__G7nk0 {
  padding: 0 51px 35px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.changedCustomerTitle__U1Zs7 {
  margin-top: 20px;
  max-width: 270px;
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  text-transform: uppercase;
  color: var(--tables-title-text);
}

.changedCustomerInfo__SWVup {
  width: 100%;
  margin-top: 35px;
}

.changedCustomerInfoLabel__S9_2D {
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}

.changedCustomerInfoValue__SREMG {
  color: var(--inputs-filled-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
  text-transform: uppercase;
  text-align: left;
  margin-top: 5px;
  padding: 15px;
  border-radius: 2px;
  border: 1px solid var(--inputs-focus-stroke);
  background: var(--inputs-filled-filled-surface);
}

.changedCustomerFooter__LlkFt {
  color: var(--tables-secondary-row-sub-title-text);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-top: auto;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/SwitchCustomerModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,OAAA;AAzEF;;AA4EA;EACE,mBAAA;EACA,kBAAA;EA1BA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA9CF;;AAwEA;EACE,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;AArEF;;AAwEA;EACE,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AArEF;;AAwEA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,+BAAA;AArEF;;AAwEA;EACE,WAAA;EACA,gBAAA;AArEF;;AAwEA;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AArEF;;AAwEA;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,4CAAA;EACA,+CAAA;AArEF;;AAwEA;EACE,iDAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AArEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.modalSwitchCustomer {\n  height: 464px;\n  width: 372px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.modalBody {\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n}\n\n.modalBodyTitle {\n  margin-bottom: 35px;\n  text-align: center;\n\n  @include modalTitle;\n}\n\n.extraText {\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: none;\n  display: block;\n  margin: 25px auto 0;\n}\n\n.modalFooter {\n  padding: 0 51px 35px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.changedCustomerTitle {\n  margin-top: 20px;\n  max-width: 270px;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 20px;\n  text-align: center;\n  text-transform: uppercase;\n  color: var(--tables-title-text);\n}\n\n.changedCustomerInfo {\n  width: 100%;\n  margin-top: 35px;\n}\n\n.changedCustomerInfoLabel {\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.changedCustomerInfoValue {\n  color: var(--inputs-filled-text);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 12px;\n  text-transform: uppercase;\n  text-align: left;\n  margin-top: 5px;\n  padding: 15px;\n  border-radius: 2px;\n  border: 1px solid var(--inputs-focus-stroke);\n  background: var(--inputs-filled-filled-surface);\n}\n\n.changedCustomerFooter {\n  color: var(--tables-secondary-row-sub-title-text);\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n  margin-top: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalSwitchCustomer": `modalSwitchCustomer__rKsHj`,
	"modalBody": `modalBody__bJ9Qf`,
	"modalBodyTitle": `modalBodyTitle__S1JId`,
	"extraText": `extraText__Qg3OK`,
	"modalFooter": `modalFooter__G7nk0`,
	"changedCustomerTitle": `changedCustomerTitle__U1Zs7`,
	"changedCustomerInfo": `changedCustomerInfo__SWVup`,
	"changedCustomerInfoLabel": `changedCustomerInfoLabel__S9_2D`,
	"changedCustomerInfoValue": `changedCustomerInfoValue__SREMG`,
	"changedCustomerFooter": `changedCustomerFooter__LlkFt`
};
module.exports = ___CSS_LOADER_EXPORT___;
